// extracted by mini-css-extract-plugin
module.exports = {"container":"SpecSection_container__9fXDV"};